import React from "react";

import * as FullStory from "@fullstory/browser";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "./index.scss";
import App from "./components/App";
import configureStore from "./configureStore";
import * as serviceWorker from "./serviceWorker";
import { initializeEventLogger } from "./shared/eventLogger";

const store = configureStore({});
const { NODE_ENV } = process.env;

FullStory.init({ orgId: "DWHRJ", devMode: NODE_ENV !== "production" });
initializeEventLogger();

// Render App
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

serviceWorker.unregister();
